import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { JobState } from '../../store/state/job-details.state';
import { jobDetailsLoaded } from '../../store/selectors/job-details.selectors';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { JobDetails } from '../../../models/job-details.model';
import { ExternalJobDisplayInputDto } from 'src/app/shared/models/external-job-display-input.dto';

@UntilDestroy()
@Component({
    selector: 'nova-locums-recruiter-schedule',
    templateUrl: './locums-recruiter-schedule.component.html',
    styleUrls: ['./locums-recruiter-schedule.component.scss']
})
export class LocumsRecruiterScheduleComponent implements OnInit {
    @Input() displayConfigData: ExternalJobDisplayInputDto;

    job: JobDetails;
    hasContent = false;
    constructor(private readonly _store: Store<JobState>) {}

    ngOnInit(): void {
        this._store
            .select(jobDetailsLoaded)
            .pipe(untilDestroyed(this))
            .subscribe((e) => {
                if (e.success) {
                    this.job = e.job;
                    this.hasContent =
                        this.job.scheduleDetailsText !== null &&
                        this.extractContent(this.job.scheduleDetailsText) !== '';
                }
            });
    }

    extractContent(s: string): string {
        const span = document.createElement('span');
        span.innerHTML = s;
        return span.textContent.trim() || span.innerText.trim();
    }
}
